import { GoCheckCircle } from "react-icons/go"

export interface ICheckList {
  items: string[]
  className?: string
}

export default function CheckList({ items, className }: ICheckList) {
  return (
    <ul className={"px-0 md:px-8 font-inter" + " " + className}>
      {items.map((item, i) => (
        <li key={`components/CheckList/${i}`} className="flex">
          <span className="text-gold pr-8">
            <GoCheckCircle size={34} />
          </span>

          <p className="grow text-xl">{item}</p>
        </li>
      ))}
    </ul>
  )
}
